module.exports = __webpack_public_path__ + "3cfa61964d4cab49dee098e9432a51b5.jpg";